import script from "./PaymentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentPage.vue?vue&type=script&setup=true&lang=js"

import "./PaymentPage.vue?vue&type=style&index=0&id=43ed18a0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ed18a0"]])

export default __exports__